import { PageConfig } from "../../../components/content-blocks/forms/customer-form-types";

export const introConfig: PageConfig[] = [
  {
    name: "overview1",
    title: "Whānau Reo - 12 Week Kāinga Journey",
    elements: [
      {
        type: "html",
        html: `
<p>
  <table>
    <tbody>
      <tr>
        <td><strong>Date:</strong></td>
        <td>Commencing March 2026, for 12 weeks</td>
      </tr>
      <tr>
        <td><strong>Where:</strong></td>
        <td>Wairau – hosted in your own kāinga</td>
      </tr>
    </tbody>
  </table>
</p>
<p>
  The purpose of the Whānau Reo – 12‑Week Kāinga Journey is to revitalise te reo
  Māori within Rangitāne uri by supporting whānau to establish sustained daily
  immersion opportunities in their own kāinga. Guided by Te Matahiapo Hynes,
  each whānau develops and implements a tailored Whānau Reo Plan, supported with
  reo resource packs and weekly guidance to build confidence, consistency, and
  natural intergenerational reo use. This lays the foundation for a programme
  that grows future reo champions and long‑term reo kāinga environments across
  Rangitāne.
</p>
      `,
      },
    ],
  },
  {
    name: "overview2",
    title: "Creating a Larger Whānau Group",
    elements: [
      {
        type: "html",
        html: `
<p>
  If you would like to create a wider whānau rōpū, you are welcome to do so. For
  example, you and your whānau may apply and invite an Aunty, cousin or other
  wider whānau member to join the journey. However, all participating whānau
  must be committed to the full kaupapa and attend each wānanga.
</p>
<p>
  We have capacity for 10 households, so spaces are limited. 
</p>
<p>
  All expressions of interest must be submitted no later than 12:00pm, Monday 9
  March 2026. Please be aware, expressions of interest may close earlier if we
  reach capacity.
</p>
      `,
      },
    ],
  },
  {
    name: "commitment",
    title: "Whānau Reo - 12 Week Kāinga Journey",
    elements: [
      {
        type: "html",
        html: `
<p>
  <ul>
    <li>
      Whānau must feel comfortable hosting the wānanga in their own kāinga.
    </li>
    <li>
      Our facilitator will support whānau to learn in a fun, safe and inclusive
      environment.
    </li>
    <li>
      All resources will be provided, and kai will be supplied at each wānanga.
    </li>
    <li>
      Your kāinga must have at least two registered whānau members, of any age,
      residing in the household.
    </li>
    <li>
      If you are an individual who wishes to participate, please still complete
      the EOI, we will be in touch.
    </li>
    <li>
      Funding and spaces are limited for this first round.
    </li>
  </ul>
</p>
      `,
      },
    ],
  },
];
